export enum TraitType {
  OVERSEAS_PURCHASE_AGENCY = 'OVERSEAS_PURCHASE_AGENCY',
  OVERSEAS_DIRECT_PURCHASE = 'OVERSEAS_DIRECT_PURCHASE',
}